import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { ControlGroup } from './ControlGroup';
import { Toggle } from './Toggle';
import { SmartInput } from './SmartInput';

interface GeneralDisplaySectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const GeneralDisplaySection: React.FC<GeneralDisplaySectionProps> = ({ config, setConfig }) => (
  <>
    <SectionLabel icon="fa-display" darkMode={config.darkMode}>Master Display Controls</SectionLabel>
    <div className="grid grid-cols-2 gap-3 w-full p-4 rounded-3xl border bg-neutral-500/5 border-neutral-500/10 mb-2">
      <div className="flex items-center justify-between col-span-1 border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Dark Mode</span>
        <Toggle active={config.darkMode} onClick={() => setConfig(p => ({...p, darkMode: !p.darkMode}))} color="bg-neutral-700" />
      </div>
      <div className="flex items-center justify-between col-span-1 border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">RGB Colors</span>
        <Toggle active={config.rgbLighting} onClick={() => setConfig(p => ({...p, rgbLighting: !p.rgbLighting}))} color="bg-indigo-500" />
      </div>
      <SmartInput label="Title Size" min={10} max={72} value={config.titleFontSize} onChange={v => setConfig(p => ({...p, titleFontSize: v}))} darkMode={config.darkMode} />
      <div className="flex items-center justify-between col-span-1 border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Follow Ball</span>
        <Toggle active={config.cameraFollow} onClick={() => setConfig(p => ({...p, cameraFollow: !p.cameraFollow}))} />
      </div>
    </div>

    <SectionLabel icon="fa-align-center" darkMode={config.darkMode}>Footer Settings</SectionLabel>
    <div className="flex flex-col gap-3 w-full p-4 rounded-3xl border bg-neutral-500/5 border-neutral-500/10 mb-2">
      <ControlGroup label="Footer Text">
        <input 
          type="text" 
          value={config.footerText} 
          onChange={e => setConfig(p => ({...p, footerText: e.target.value}))} 
          className={`w-full px-3 py-1.5 border rounded-xl text-xs font-bold outline-none ${config.darkMode ? 'bg-neutral-800 border-neutral-700 text-white' : 'bg-white border-neutral-200 text-neutral-800'}`}
        />
      </ControlGroup>
      <div className="grid grid-cols-2 gap-3">
        <ControlGroup label="Footer Color">
          <input type="color" value={config.footerTextColor} onChange={e => setConfig(p => ({...p, footerTextColor: e.target.value}))} className="w-full h-8 rounded-lg cursor-pointer bg-transparent" />
        </ControlGroup>
        <SmartInput label="Footer Size" min={10} max={60} value={config.footerFontSize} onChange={v => setConfig(p => ({...p, footerFontSize: v}))} darkMode={config.darkMode} />
      </div>
    </div>
  </>
);